import { createSlice } from "@reduxjs/toolkit";

interface MyScanState {
    isRenamePanelOpen?: boolean;
    isSchedulePanelOpen?: boolean
    scan_id: string;
    scanName: string;
    frequency?: string
    frequency_id?: string
    atTime?: string
    schedule_id?: string
    date?: string
    day?: string
    statusTemp?: any
    type?: string
    ip_range?: string[]
}

const myScanSlice = createSlice({
    name: 'onPremMyscan',
    initialState: { 
        isRenamePanelOpen: false, 
        isSchedulePanelOpen: false, 
        scan_id: "", 
        scanName: "", 
        frequency: "", 
        frequency_id: "",
        atTime: "", 
        schedule_id: "",
        date: "",
        day: "",
        statusTemp: null,
        type: "",
        ip_range: []
    } as MyScanState,
    reducers: {
        renamePanel(state: MyScanState, action) {
            state.isRenamePanelOpen = action.payload.isRenamePanelOpen;
            state.scan_id = action.payload.scan_id;
            state.scanName = action.payload.scanName
        },
        changeSchedule(state: MyScanState, action) {
            state.isSchedulePanelOpen = action.payload.isSchedulePanelOpen
            state.scan_id = action.payload.scan_id;
            state.scanName = action.payload.scanName
            state.frequency = action.payload.frequency
            state.frequency_id = action.payload.frequency_id
            state.atTime = action.payload.atTime
            state.schedule_id = action.payload.schedule_id
            state.date = action.payload.date
            state.day = action.payload.day
            state.type = action.payload.type
            state.ip_range = action.payload.ip_range
        },
        scanInformaton(state: MyScanState, action) {
            state.scan_id = action.payload.scan_id;
            state.statusTemp = action.payload.statusTemp;
        }
    }
})

export const myScanActions = myScanSlice.actions
export default myScanSlice.reducer